import { isBluetoothDevice } from './bluetoothDeviceUtil';
function isFirstFrequency(frequency, hearingProfile) {
    return Object.keys(hearingProfile)[1] === frequency.toString();
}
/**
 * Checks if hlaa state is constant zero tone heard
 * @param hearingProfile Hearing profile of device
 * @param deviceModelId Model id of device
 * @param frequency Frequency
 * @param toneSequence Hlaa tone sequence
 * @param isFirstRun True if first hlaa run
 * @returns Returns true if hlaa state is constant zero tone heard
 */
export function isConstantZeroToneHeard(hearingProfile, deviceModelId, frequency, toneSequence, isFirstRun) {
    var zeroCount = 0;
    var result = false;
    if (!isBluetoothDevice(deviceModelId) && isFirstFrequency(frequency, hearingProfile) && isFirstRun) {
        for (var _i = 0, toneSequence_1 = toneSequence; _i < toneSequence_1.length; _i++) {
            var tone = toneSequence_1[_i];
            if (tone === 0)
                zeroCount++;
            else
                zeroCount = 0;
            if (zeroCount >= 3) {
                result = true;
                break;
            }
        }
    }
    return result;
}
